// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__5OaAM","banner--alert":"Banner_banner--alert__wjLg1","banner--info":"Banner_banner--info__mRNfi","banner--error":"Banner_banner--error__vUuKn"};